/**
 * Validator module
 *
 * Validator entry:
 *
 *
 */

export default {
  errors: [],
  validator: {}
};
